import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "./initialState";
import api from "../api";

export const GetAllLayananKodePayByLayananID = createAsyncThunk(
  "layananKodepay/GetAllLayananKodePayByLayananID",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(
        `${api}master/layanan_kodepay/get_by_layanan_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllLayananKodepay = createAsyncThunk(
  "layananKodepay/GetAllLayananKodepay",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(
        `${api}master/layanan_kodepay/all?${data.url}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleLayananKodepay = createAsyncThunk(
  "layananKodepay/GetSingleLayananKodepay",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/layanan_kodepay/get_by_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const CreateLayananKodepay = createAsyncThunk(
  "layananKodepay/CreateLayananKodepay",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}master/layanan_kodepay`,
        {
          nama: data.nama,
          id_layanan: data.id_layanan,
          id_dokumen: data.id_dokumen,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const EditLayananKodepay = createAsyncThunk(
  "layananKodepay/EditLayananKodepay",
  async (data, thunkAPI) => {
    try {
      const response = await axios.put(
        `${api}master/layanan_kodepay/${data.id}`,
        {
          nama: data.nama,
          id_layanan: data.id_layanan,
          id_dokumen: data.id_dokumen,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const DeleteLayananKodepay = createAsyncThunk(
  "layananKodepay/DeleteLayananKodepay",
  async (data, thunkAPI) => {
    let listData;
    try {
      const responseDelete = await axios.delete(
        `${api}master/layanan_kodepay/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );

      if (responseDelete.data.success) {
        listData = await axios.get(
          `${api}master/layanan_kodepay/all?${data.url}`,
          {
            headers: {
              Authorization: data.token,
            },
          }
        );

        return {
          delete: responseDelete.data,
          meta: listData.data.meta,
          items: listData.data.items,
        };
      }
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const layananKodepaySlice = createSlice({
  name: "layananKodepay",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all Layanan kode payment by id layanan
    builder.addCase(GetAllLayananKodePayByLayananID.pending, loadingHandler);
    builder.addCase(GetAllLayananKodePayByLayananID.fulfilled, fulfilledHandler);
    builder.addCase(GetAllLayananKodePayByLayananID.rejected, rejectedHandler);
    // get all Layanan kode payment
    builder.addCase(GetAllLayananKodepay.pending, loadingHandler);
    builder.addCase(GetAllLayananKodepay.fulfilled, fulfilledHandler);
    builder.addCase(GetAllLayananKodepay.rejected, rejectedHandler);
    // get Single Layanan kode payment
    builder.addCase(GetSingleLayananKodepay.pending, loadingHandler);
    builder.addCase(GetSingleLayananKodepay.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleLayananKodepay.rejected, rejectedHandler);
    // create Layanan kode payment
    builder.addCase(CreateLayananKodepay.pending, loadingHandler);
    builder.addCase(CreateLayananKodepay.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isCreate: true });
    });
    builder.addCase(CreateLayananKodepay.rejected, rejectedHandler);
    // edit Layanan kode payment
    builder.addCase(EditLayananKodepay.pending, loadingHandler);
    builder.addCase(EditLayananKodepay.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isEdit: true });
    });
    builder.addCase(EditLayananKodepay.rejected, rejectedHandler);
    // delete Layanan kode payment
    builder.addCase(DeleteLayananKodepay.pending, loadingHandler);
    builder.addCase(DeleteLayananKodepay.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isDelete: true });
    });
    builder.addCase(DeleteLayananKodepay.rejected, rejectedHandler);
  },
});

export const { reset } = layananKodepaySlice.actions;
export default layananKodepaySlice.reducer;
